// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20ZnV","footer":"styles_footer__Eih2m"};